import React, { Component } from "react";
import { FormGroup, FormControl, ControlLabel, PageHeader } from "react-bootstrap";
import LoaderButton                 from "../components/LoaderButton";
import Amplify, { Auth }            from 'aws-amplify';
import { invokeGetAppMainUserId,
         invokeGetGeneralPostureNotAUserProfile,
         getUserProfileValidation } from "../utils/AwsInvoke";
import { Colors }                   from "../utils/Colors"
import { WhiteLabel }               from "../utils/WhiteLabelProps";
import "../css/Login.css";


var white_label = WhiteLabel();
var company_id  = white_label.company_id;
var portal_id   = white_label.portal_id; // portal id comes from url query string
var url_users_email = white_label.url_users_email;

const posture_health_company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";
const REACT_APP_COMPANY_LOGO_SQ = sessionStorage.getItem('company_login_logo'); //process.env.REACT_APP_COMPANY_LOGO_SQ
const REACT_APP_S3_BUCKET_URL   = sessionStorage.getItem('s3_bucket_url');
const REACT_APP_S3_BUCKET_NAME  = sessionStorage.getItem('s3_bucket_name');

const REACT_APP_COMPANY_LOGO_URL = "https://" + REACT_APP_S3_BUCKET_URL + "/" + REACT_APP_S3_BUCKET_NAME + "/logos/" + REACT_APP_COMPANY_LOGO_SQ;


export default class Login extends Component {
    constructor(props) {
        super(props);

        var email ="";

        if(url_users_email != undefined) email = url_users_email;

        this.state = {
          isLoading: false,
          email: email,
          password: "",
          error: false,
          autoLogin: false
        };
    }

    async componentDidMount() {
      try {
          await Auth.currentSession();

          console.log("authenticating ...");
          // temp remove 5/26: this.props.userHasAuthenticated(true);
      }
      catch(e) {
        if (e !== 'No current user') {
          console.log("error dude: " + e);
        }
      }

      this.setState({ isAuthenticating: false });
    }

    componentWillUnmount () {

    }

    async componentDidUpdate(prevProps, prevState) {
        // Auto Login URL //
        // http://localhost:3001/login?company_id=69c4ac91-69b7-11ea-b027-a3b6eeba595f&portal_id=148955cc-a6ae-402b-9639-1f65be8d9ed6&email=klu@kevinlu.com
        //console.log("+++ componentDidUpdate +++");
        var autoLogin = prevState.autoLogin;

        if(!autoLogin)
            this.setState({autoLogin: true});

        console.log("Test autoLogin: " + autoLogin);
        console.log("Test company_id: " + company_id);
        console.log("Test url_users_email: " + url_users_email);
        console.log("Test portal_id: " + portal_id);

        if(autoLogin && company_id == "69c4ac91-69b7-11ea-b027-a3b6eeba595f" && url_users_email != undefined && portal_id === "148955cc-a6ae-402b-9639-1f65be8d9ed6") {

                console.log("--------------");
                console.log("Your'e coming in from Posture Health dude!");
                //console.log("company_id: " + company_id);
                //console.log("url_users_email: " + url_users_email);
                //console.log("portal_id: " + portal_id);

                this.singleSignOnPHUser(url_users_email);
        }
    }

    validateForm() {
        return this.state.email.length > 0 && this.state.password.length > 0;
    }

    handleChange = event => {
        this.setState({
          [event.target.id]: event.target.value
        });
    }

    async singleSignOnPHUser (user_email) {
        var tmp_user_email   = "no.user.posture.health@gmail.com";
        var tmp_password     = "123123";
        var check_user_login = true;

        await Auth.signIn(tmp_user_email, tmp_password)
            .then(user => {
                console.log("1. Auth signed in.");
             })
            .catch(err => {
                console.log("1. Auth error: " + err.message),
                check_user_login = false
                this.setState({ isLoading: false, error: true });
            });

            if(check_user_login) {
                    // Continue checking for user if there's NO LOGIN Error above
                    var company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f"; // PH id;
                    /*console.log("2. user_email: " + user_email);
                    console.log("3. company_id: " + company_id);
                    console.log("4. portal_id: " + portal_id);*/
                    await getUserProfileValidation(user_email, company_id);

                    //// GET USER ID FROM USER EMAIL ////
                    var result = await invokeGetAppMainUserId(user_email);

                    if(result.status === "user_suspended") {
                        alert("Sorry, this account has been suspended")
                        this.setState({ isLoading: false, error: true });

                    // PH Portal_id =  148955cc-a6ae-402b-9639-1f65be8d9ed6
                    // Ex: http://localhost:3000/login?portal_id=148955cc-a6ae-402b-9639-1f65be8d9ed6
                    // portal id comes from url query string
                    } else if(result.status === true) {
                            console.log("Posture Health login successful!");
                            // If user is a Posture client, automatically sign them up and login //
                            var user_id       = result.user_id;
                            var trainer_id    = "69c4ac90-69b7-11ea-b027-a3b6eeba595f"; // result.trainer_id;
                            var trainer_name  = "Daniel"; // result.trainer_name;
                            var trainer_phone = "+12259078957"; // daniel's# result.trainer_phone;
                            var athlete_id    = white_label.athlete_id; // this is req'd but can be undefined; the value changes in app.js
                            var mktplc_prog_id  = white_label.mktplc_prog_id;

                            if(mktplc_prog_id != undefined)
                                localStorage.setItem('previewMktplcProgramId', mktplc_prog_id);

                            this.props.setGlobalUserProps(user_id, user_email, company_id, trainer_id, trainer_name, trainer_phone, athlete_id);
                            this.props.userHasAuthenticated(true);
                    } else {
                        console.log("Error");
                        this.setState({ isLoading: false, error: true });
                    }
            }
    }

    handleSubmit = async event => {
        event.preventDefault();

        this.setState({
            isLoading: true,
            error: false
        });

        try {
            const user_email = this.state.email;
            const password   = this.state.password;
            // If login() is incorrect, there is an error and the below is not processed //
            // Not working: receive a "No user pool"  error message
            //  await this.login(email, this.state.password);
            var check_user_login = true;

            // Check if athlete is coming from Posture Health domain
            // and if so, automatically log them in ???
            //var company_id = white_label.company_id;
            //console.log("company_id: " + company_id);

            if(company_id == "69c4ac91-69b7-11ea-b027-a3b6eeba595f" && portal_id === "148955cc-a6ae-402b-9639-1f65be8d9ed6") {
                    // Get Generic User Profle //
                    /* console.log("Get user profile...");
                    //var tmp_result = await getUserProfileValidation(user_email, company_id); // doesn't work since user hasn't logged in yet
                    //invokeGetGeneralPostureNotAUserProfile(); // doesn't work since user hasn't logged in yet

                    var tmp_user_email = "no.user.posture.health@gmail.com";
                    var tmp_password   = "123123";
                    console.log("0. TEST Single sign-on");

                    await Auth.signIn(tmp_user_email, tmp_password)
                        .then(user => {
                            console.log("1. Auth signed in.");
                         })
                        .catch(err => {
                            console.log("1. Auth error: " + err.message),
                            check_user_login = false
                            this.setState({ isLoading: false, error: true });
                        });

                        if(check_user_login) {
                                // Continue checking for user if there's NO LOGIN Error above
                                var company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f"; // PH id;
                                console.log("3. user_email: " + user_email);
                                console.log("4. company_id: " + company_id);
                                console.log("5. portal_id: " + portal_id);
                                await getUserProfileValidation(user_email, company_id);

                                //// GET USER ID FROM USER EMAIL ////
                                var result = await invokeGetAppMainUserId(user_email);

                                if(result.status === "user_suspended") {
                                    alert("Sorry, this account has been suspended")
                                    this.setState({ isLoading: false, error: true });

                                // PH Portal_id =  148955cc-a6ae-402b-9639-1f65be8d9ed6
                                // Ex: http://localhost:3000/login?portal_id=148955cc-a6ae-402b-9639-1f65be8d9ed6
                                // portal id comes from url query string
                                } else if(result.status === true) {
                                        console.log("Posture Health login successful!");
                                        // If user is a Posture client, automatically sign them up and login //
                                        var user_id       = result.user_id;
                                        var trainer_id    = "69c4ac90-69b7-11ea-b027-a3b6eeba595f"; // result.trainer_id;
                                        var trainer_name  = "Daniel"; // result.trainer_name;
                                        var trainer_phone = "+12259078957"; // daniel's# result.trainer_phone;
                                        var athlete_id    = white_label.athlete_id; // this is req'd but can be undefined; the value changes in app.js

                                        console.log("result.trainer_name: " + result.trainer_name);
                                        this.props.setGlobalUserProps(user_id, user_email, company_id, trainer_id, trainer_name, trainer_phone, athlete_id);
                                        this.props.userHasAuthenticated(true);
                                } else {
                                    console.log("6. Error");
                                    this.setState({ isLoading: false, error: true });
                                }
                        }*/
            } else {
                    await Auth.signIn(user_email, password)
                        .then(user => {
                            /*console.log("Signing in - Amplify user auth: " + user)
                            for(var key in user) {
                                console.log("key: " + key);
                                console.log("user: " + user[key]);
                            }*/
                            console.log("Login successful!");
                         })
                        .catch(err => {
                            console.log("auth error: " + err.message),
                            check_user_login = false
                            this.setState({ isLoading: false, error: true });
                        });

                        if(check_user_login) {

                                // begin test //
                                /* var tmp_result = await invokeGetGeneralPostureNotAUserProfile();
                                var test = tmp_result.tmp_user_email;
                                console.log("tmp_result: " + tmp_result);
                                console.log("General Posture Health Profile email: " +  test);
                                // end test //
                                /* */
                                // Continue checking for user if there's NO LOGIN Error above
                                var company_id = white_label.company_id;
                                await getUserProfileValidation(user_email, company_id);

                                //// GET USER ID FROM USER EMAIL ////
                                var result = await invokeGetAppMainUserId(user_email);
                                //console.log("result.status: " + result.status);

                                if(result.status === "user_suspended") {
                                    alert("Sorry, this account has been suspended")
                                    this.setState({ isLoading: false, error: true });
                                } else if(result.status === true) {
                                    var user_id       = result.user_id;
                                    var company_id    = result.company_id;
                                    var trainer_id    = result.trainer_id;
                                    var trainer_name  = result.trainer_name;
                                    var trainer_phone = result.trainer_phone;
                                    var athlete_id    = white_label.athlete_id; // this is req'd but can be undefined; the value changes in app.js

                                    this.props.setGlobalUserProps(user_id, user_email, company_id, trainer_id, trainer_name, trainer_phone, athlete_id);
                                    this.props.userHasAuthenticated(true);
                                } else {
                                    this.setState({ isLoading: false, error: true });
                                }
                        }
                    // end Await
            }

        } catch (e) {
            this.setState({ isLoading: false, error: true });
        }
    }

    handleSignup (event) {
        this.props.history.push(event.currentTarget.getAttribute("href"));
    }

    render() {
        var error_text;
        var sign_up = <div></div>

        /* Removing sign up link since all users should now be going through the PH desktop app portal
        if(company_id == posture_health_company_id)
            sign_up = <div className="loginLink">
                            New to Posture Health? <a href='/signup' onClick={this.handleSignup.bind(this)}>Sign Up here</a>.
                      </div>*/
        var member_login  = <span style={{fontSize:34, textAlign:"center"}}>
                                Member Login
                           </span>

       if(this.state.error)
           error_text = "Your username or password was incorrect."
           
        var general_login = <div>
                                <form onSubmit={this.handleSubmit} style={{position:"relative", top:"-30px"}}>
                                  <FormGroup controlId="email" bsSize="large">
                                    <ControlLabel className="loginTFLabels">Email</ControlLabel>
                                    <FormControl
                                      autoFocus
                                      type="email"
                                      value={this.state.email}
                                      onChange={this.handleChange}
                                    />
                                  </FormGroup>
                                  <FormGroup controlId="password" bsSize="large">
                                    <ControlLabel className="loginTFLabels">Password</ControlLabel>
                                    <FormControl
                                      value={this.state.password}
                                      onChange={this.handleChange}
                                      type="password"
                                    />
                                  </FormGroup>
                                  <span style={{color:"red", paddingTop:"10px", paddingLeft: "6px"}}> {error_text} </span>
                                  <span style={{display:"block", paddingTop:"5px"}}/>
                                  <LoaderButton
                                      block
                                      bsSize    = "large"
                                      disabled  = {!this.validateForm()}
                                      type      = "submit"
                                      btncolor = { Colors.ok_button_bg }
                                      fontSize  = {20}
                                      height    = {40}
                                      isLoading = {this.state.isLoading}
                                      text      = "Login"
                                      loadingText = "Logging in…"
                                    />
                                </form>
                                { sign_up }

                            </div>

        // Auto Login Message //
        if(company_id == "69c4ac91-69b7-11ea-b027-a3b6eeba595f" && url_users_email != undefined && portal_id === "148955cc-a6ae-402b-9639-1f65be8d9ed6") {
                member_login = <div style={{textAlign:"center", fontSize: 23}}>
                                    Loading a curated list of workout programs for you...
                                </div>
                general_login = "";
        }

        return (
          <div className="Login">

                <span className="loginLogo">
                    <img src={REACT_APP_COMPANY_LOGO_URL} width="140"/><br/><br/>
                { member_login }
                </span>
                { general_login }
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/Login.js